<template>
  <div class="pdf-container">
    <PDFViewer :config="viewerConfig" class="pdf-viewer" @ready="onViewerReady" />
  </div>
</template>

<script>
import { PDFViewer } from "@embedpdf/vue-pdf-viewer";

export default {
  name: "PdfViewModel2",

  components: {
    PDFViewer
  },

  props: {
    pdfUrl: {
      type: String,
      required: true
    },
    theme: {
      type: String,
      default: "dark"
    }
  },

  computed: {
    viewerConfig() {
      return {
        documentManager: {
          initialDocuments: [
            {
              url: this.pdfUrl,
              autoActivate: true
            }
          ]
        },

        theme: this.theme
      };
    }
  },

  methods: {
    onViewerReady() {
      return
    }
  }
};
</script>

<style scoped>
.pdf-container {
  width: 100%;
  height: 100%;
  overflow: hidden;
}

.pdf-viewer {
  width: 100%;
  height: 100%;
  display: block;
}
</style>